export interface PreviewPlacement {
  /** Horizontal centre of the free space, in px from the window's left edge */
  center: number
  /** Width of the free space, in px */
  space: number
}

/**
 * Finds the wider free space beside the view, so the preview doesn't cover the grid.
 * Undefined when neither side is `minSpace` wide, e.g. when the view fills the window.
 */
export function getPreviewPlacement(
  view: { left: number, right: number },
  windowWidth: number,
  minSpace: number
): PreviewPlacement | undefined {
  const leftSpace = view.left
  const rightSpace = windowWidth - view.right
  const space = Math.max(leftSpace, rightSpace)

  if (space < minSpace) {
    return undefined
  }

  const start = leftSpace >= rightSpace ? 0 : view.right

  return { center: start + space / 2, space }
}
